import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class CqFieldService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/cq-fields', query);
  }

  create(body: any) {
    return this.post('/cq-fields', body);
  }

  find(id) {
    return this.get('/cq-fields/' + id);
  }

  update(id, body) {
    return this.put('/cq-fields/' + id, body);
  }

  _delete(id) {
    return this.delete('/cq-fields/' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/CqField.service.ts